export default __webpack_public_path__ + "images/Vietnamese.76f286.jpg";